import React from 'react';
import './StatsBar.css';

const stats = [
  { num: '500+', label: 'Happy Clients' },
  { num: '50', label: 'States Served' },
  { num: '98%', label: 'Satisfaction Rate' },
  { num: '24hr', label: 'Avg. Turnaround' },
  { num: '$2M+', label: 'Refunds Secured' },
];

const StatsBar = () => (
  <div className="stats-bar">
    <div className="container">
      <div className="stats-grid">
        {stats.map((s) => (
          <div className="stat-item" key={s.label}>
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default StatsBar;
